import React from "react";
import {Routes, Route, Navigate} from "react-router-dom";
import {authRoutes} from "../routes.js";
import CookieService from "../service/cookieService";

class Auth extends React.Component {
  redirectToCustomerPage = () => {
    const {history} = this.props;
    if (history) history.push("/app/customer");
  };

  componentDidMount() {
    if (CookieService().isTokenAvailable()) {
      this.redirectToCustomerPage();
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("bg-default");
  }

  getRoutes = () => {
    return authRoutes.map((route, key) => {
      const {path, component: Component} = route;
      return <Route path={path} element={<Component />} key={key} />;
    });
  };

  render() {
    return (
      <Routes>
        {this.getRoutes()}
        <Route path="*" replace element={<Navigate to="login" />} />
      </Routes>
    );
  }
}

export default Auth;
